import api from "@/plugins/api/EntryPoint";

export default {
  async getPaymentUrl(params, callBackFn) {
    // console.log("getPaymentUrl " + JSON.stringify(params));
    return await api.post(`easy-pay/payment`, params, callBackFn);
  },
  async getEasyPayCardsList(callBackFn) {
    await api.post(`easy-pay/card-list`, null, callBackFn);
  },
  async getSavedCards(params, callBackFn) {
    return await api.post(`stripe/get-saved-cards`, params, callBackFn);
  },
  async getEasyPaySaveCardsPage(callBackFn) {
    await api.post(`easy-pay/3d-secure-url-alt`, {}, callBackFn);
  },
  async saveCardWithFullData(params, callBackFn) {
    return await api.post(`stripe/save-full-card`, params, callBackFn);
  },
  async payWithSavedCard(params, callBackFn) {
    return await api.post(`easypay/pay-with-saved-card`, params, callBackFn);
  },
  async payDistributionWithSavedCard(params, callBackFn) {
    return await api.post(`easy-pay/pay-distribution-with-saved-card`, params, callBackFn);
  },
  async saveStripeToken(params, callBackFn) {
    return await api.post(`stripe/save-stripe-token`, params, callBackFn);
  },
  async saveCardWithStripeToken(params, callBackFn) {
    return await api.post(`stripe/save-stripe-token`, params, callBackFn);
  },
  async deleteCard(params, callBackFn) {
    console.log("DELETE CARD: " + JSON.stringify(params));
    return await api.post(`easy-pay/delete-card`, params, callBackFn);
  },
  async getStripe(params, callBackFn) {
    return await api.post("stripe/getUrl", params.stripeData, callBackFn);
  },
  async cancelSubscription(params, callBackFn) {
    return await api.post(
      "stripe/cancel-subscription",
      params.stripeData,
      callBackFn
    );
  },
  async createSubscriptionDirect(params, callBackFn) {
    console.log(
      " createSubscriptionDirect stripeData",
      JSON.stringify(params.stripeData)
    );
    return await api.post(
      "stripe/create-subscription-direct",
      params.stripeData,
      callBackFn
    );
  },
};
